import type { WorkShiftCell } from "@senciamatch/shared/models/workShiftCell";
import { useNavigate } from "react-router-dom";

interface Props {
  workShiftCell: WorkShiftCell | undefined;
}

const CellNull = () => {
  return (
    <td className="border border-gray-100 w-[270px] h-[80px]">
      <div className="flex items-center justify-center h-full w-[270px]">
        <div className="text-gray-500">-</div>
      </div>
    </td>
  );
};

export const Cell = (props: Props) => {
  const { workShiftCell } = props;
  const navigate = useNavigate();

  if (!workShiftCell) return <CellNull />;

  const handleClick = () => {
    // 新しいルートに遷移
    navigate(`/matchings/${workShiftCell.workShiftId}/modify`);
  };

  return (
    <td className="border border-gray-100 w-[270px] h-[80px]">
      <div
        className="flex flex-col items-center justify-center h-full w-[270px] relative cursor-pointer hover:bg-gray-50"
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleClick();
        }}
      >
        <div className="absolute top-2 left-2">
          {workShiftCell.status === "Confirmed" && <img src="/icons/confirmed.svg" alt="confirmed" />}
          {workShiftCell.status === "NotConfirmed" && <img src="/icons/not_confirmed.svg" alt="not confirmed" />}
        </div>
        <p className="text-center">
          {workShiftCell.buildingName ?? (workShiftCell.shiftSymbol === "X" ? "" : "未割当")}
        </p>
        <p className="text-center">
          {workShiftCell.shiftSymbol}
          {workShiftCell.buildingShiftId && (
            <>
              ({String(workShiftCell.startHour).padStart(2, "0")}:{String(workShiftCell.startMinute).padStart(2, "0")} -{" "}
              {String(workShiftCell.endHour).padStart(2, "0")}:{String(workShiftCell.endMinute).padStart(2, "0")})
            </>
          )}
        </p>
        {workShiftCell.isFirstShift && <p className="text-blue-500">初担当</p>}
      </div>
    </td>
  );
};
